// Backward-compat shim — file moved to ./support/support-chat-open-context
export * from "./support/support-chat-open-context";
